module.exports = __webpack_public_path__ + "img/PT500.338b7216.png";